import { Button, Input, message, notification, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { createUser, deleteUser, getUserList } from '../../lib/api/user-api';
import { AwsUserAttribute, User } from '../../types/users';
import AddUser from './AddUser';
import UserOverviewTableColumns from './UserOverviewTableColumns';

interface TableRow {
  key: string;
  username: string;
  role: string;
}

const UserOverview = () => {
  const [userData, setUserData] = useState<User[]>([]);
  const [filteredUserData, setFilteredUserData] = useState<TableRow[]>([]);
  const [dataFilter, setDataFilter] = useState<string>('');
  const [addUserVisible, setAddUserVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  // const [userList, setUserList] = useState<User[]>();

  const fetchUserList = async () => {
    setLoading(true);
    await getUserList()
      .then(response => {
        let users: User[] = [];
        users = response.Users.map(awsUser => {
          return {
            username: awsUser.Attributes.find((attribute: AwsUserAttribute) => attribute.Name === 'email')
              ?.Value as string,
            role:
              (awsUser.Attributes.find((attribute: AwsUserAttribute) => attribute.Name === 'custom:role')
                ?.Value as string) === 'ADMIN'
                ? 'ADMIN'
                : 'USER',
          };
        });
        setUserData(users);
      })
      .catch((error: Error) => {
        setLoading(false);
        notification.error({
          message: 'Error fetching user data',
          description: error.message,
          duration: 0,
        });
      });
    setLoading(false);
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  useEffect(() => {
    setFilteredUserData(
      userData
        .filter(user => user.username.indexOf(dataFilter) > -1)
        .map((user: User) => {
          return { key: user.username, username: user.username, role: user.role || 'USER' };
        })
    );
  }, [dataFilter, userData]);

  const filterUsers = (value: string) => {
    setDataFilter(value);
  };

  const onSubmitUser = async (user: User) => {
    await createUser({
      email: user.username,
      custom_role: user.role,
      family_name: '',
      given_name: '',
    });
    setAddUserVisible(false);
    message.success('User added successfully');
    fetchUserList();
  };

  const onCloseAddUser = () => {
    setAddUserVisible(false);
  };

  const onDeleteUser = async (userToDelete: User) => {
    await deleteUser(userToDelete.username);
    message.success('User deleted successfully');
    fetchUserList();
  };

  const onChangeRole = () => {
    message.success('Role changed successfully');
    fetchUserList();
  };

  return (
    <>
      <div className="my-3 grid grid-cols-2">
        <div>
          <Input placeholder="Filter" onChange={e => filterUsers(e.currentTarget.value)} />
        </div>
        <div className="text-right">
          <Button type="primary" onClick={() => setAddUserVisible(true)}>
            Add user
          </Button>
        </div>
      </div>
      <Table
        className="ant-table-toolbox"
        dataSource={filteredUserData}
        columns={UserOverviewTableColumns(onDeleteUser, onChangeRole)}
        pagination={{ pageSize: 8 }}
        loading={loading}
      />
      <AddUser visible={addUserVisible} onSubmit={onSubmitUser} onCancel={onCloseAddUser} />
    </>
  );
};

export default UserOverview;
